import { Shield } from "lucide-react";
import { memo } from "react";

export const AccessDenied = memo(({ name }: { name: string }) => {
    return (
			<div className='flex items-center justify-center h-96'>
				<div className='text-center'>
					<Shield className='h-16 w-16 mx-auto text-muted-foreground mb-4' />
					<h3 className='text-lg font-medium mb-2'>Không có quyền truy cập</h3>
					<p className='text-muted-foreground'>Bạn không có quyền xem {name}.</p>
				</div>
			</div>
		);
});